


































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM, resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import Header from "../../components/project-create-header.vue";
import NormalCmp from "./normalCmp.vue";
import ImportCmp from "./importCmp.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
@Component({
  components: {
    Copy,
    Header,
    NormalCmp,
    ImportCmp,
    ConfirmDialog
  }
})
export default class ProjectCreateSecond extends Vue {
  private projectId: any = "";
  private project: any = {};
  private cZu: any = {};
  private cState: "normal" | "import" = "normal";
  // 确认弹窗
  private cProject: any = {};
  private confirmState: "delete" = "delete";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any =
    "点击删除后，将会删除该分组下面所有患者的数据，您确定删除么？";
  /**
   * @description 获取当前项目已有的数据
   */
  private fetch() {
    if (!this.projectId) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.projectId
      }
    };
    axios.get("api/project/groups", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.project["项目分组"] = data.data;
        this.project.project_id = this.projectId;
        this.cZu = this.project["项目分组"][0];
      });
    });
  }
  /**
   * @description 点击分组
   */
  private clickZu(command, zu) {
    switch (command) {
      case "编辑":
        zu.editing = true;
        this.$forceUpdate();
        this.$nextTick().then(() => {
          this.$refs[zu.group_id][0].focus();
        });
        break;
      case "删除":
        this.openIfDeleteConfirm(zu);
        break;
    }
  }
  /**
   * @description 修改分组的名称
   */
  private changeZuName(zu: any) {
    if (!zu["分组名称"]) {
      this.$message.error("分组名称不能为空！");
      this.fetch();
      return;
    }
    const params: any = {
      project_id: this.projectId,
      group_id: zu.group_id,
      分组名称: zu["分组名称"],
      患者入组说明: zu["患者入组说明"]
    };
    axios.post("api/project/group", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        zu.editing = false;
        this.$message.success("修改成功");
        this.fetch();
      });
    });
  }
  /**
   * @description 点击普通情况下的分组，切换
   */
  private changeCurrentZu(zu: any) {
    this.cZu = zu;
    this.cState = "normal";
  }
  /**
   * @description 新增分组
   */
  private addFenzu() {
    this.project["项目分组"].push({ 分组名称: "新建分组", editing: true });
    this.$forceUpdate();
    this.$nextTick().then(() => {
      (this.$refs.projectList as any).scrollTop = (this.$refs
        .projectList as any).offsetHeight;
      (this.$refs["new_fenzu"][0] as any).focus();
    });
  }
  /**
   * @description 创建新分组时实时更新
   */
  private newFenzuInput(e) {
    this.$forceUpdate();
  }
  /**
   * @description 创建一个新分组
   */
  private createNewZu(zu: any) {
    if (!zu["分组名称"]) {
      this.fetch();
      return;
    }
    const params: any = {
      project_id: this.projectId,
      分组名称: zu["分组名称"],
      患者入组说明: zu["患者入组说明"]
    };
    axios.post("api/project/group", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        zu.editing = false;
        this.$message.success("创建成功");
        this.fetch();
      });
    });
  }
  /**
   * @description 打开是否确定删除分组弹窗
   */
  private openIfDeleteConfirm(zu: any) {
    if (this.project["项目分组"].length === 1) {
      this.$message.warning(
        "对不起，每个项目下必须保留一个分组，如需修改分组名称，可点击重命名修改。"
      );
      return;
    }
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp =
      "点击删除后，将会删除该分组下面所有患者的数据，您确定删除么？";
    this.confirmVisible = true;
    this.cZu = zu;
  }
  /**
   * @description 删除一个分组
   */
  private deleteFenzu() {
    const params: any = {
      data: {
        project_id: this.projectId,
        group_id: this.cZu.group_id
      }
    };
    axios.delete("api/project/group", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.confirmVisible = false;
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "delete":
        this.deleteFenzu();
        break;
    }
  }
  /**
   * @description 处理当前右边显示部分变化
   */
  private handleCStateChange(val: any) {
    this.cState = val;
  }
  /**
   * @description 返回第一步修改项目信息
   */
  private back() {
    this.$router.push("/main/project/project-create-first/" + this.projectId);
  }
  /**
   * @description 前往第三页
   */
  private next() {
    const params: any = {
      project_id: this.projectId,
      group_id: this.cZu.group_id,
      分组名称: this.cZu["分组名称"],
      患者入组说明: this.cZu["患者入组说明"]
    };
    axios.post("api/project/group", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$router.push(
          "/main/project/project-create-third/" + this.projectId
        );
      });
    });
  }
  /**
   * @description 初始化
   * @enhancement 可以已进入就强制清楚前一次历史记录，替换为已有Id的第一页？
   */
  private beforeMount() {
    this.projectId = this.$route.params.project_id;
    this.fetch();
  }
}
